import { render, staticRenderFns } from "./app.vue?vue&type=template&id=217c22ce"
import script from "./app.vue?vue&type=script&lang=ts"
export * from "./app.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports